import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { CHECKOUT_CONSTANTS } from 'common/constants/SharedConstants';
import {
  getRadioOptionPanel,
  getTitlePanel,
  dispositionOptionInstruction,
  dispostionInstructionPayOnArrival,
  dispositionOptionTitle,
} from '../sharedTemplates/CheckoutDispositionOptionsViewTemplates';

const CheckoutDispositionOptionsView = props => {
  const {
    typeOptions,
    checkoutDetails,
    cartReducer,
    radioBtnChangeHandler,
    kfcToCarCollectionPointCheck,
    updateDispositionOptions,
    updateCheckoutDetails,
  } = props;

  const { type, mobilecontactlessdeliveryenabled, checkoutDispositionFirstOption } = checkoutDetails;
  const { cartData } = cartReducer;

  const getHandItToMe = () => (
    <>
      {dispositionOptionTitle({
        type,
        cartData,
        kfcToCarCollectionPointCheck,
        checkoutDetails,
        updateCheckoutDetails,
        radioBtnChangeHandler,
      })}
      {dispostionInstructionPayOnArrival({ type, checkoutDetails, updateCheckoutDetails })}{' '}
    </>
  );
  return (
    <div className={`row row-cols-12 mt-10px`}>
      {getTitlePanel(type, translateWithI18Next(typeOptions(type)))}
      <div className={`deliveryOptionsContent px-25px col-sm-8 col-12`}>
        {checkoutDispositionFirstOption === CHECKOUT_CONSTANTS?.HAND_IT_TO_ME && getHandItToMe()}

        {mobilecontactlessdeliveryenabled &&
          getRadioOptionPanel({
            type,
            checkoutDetails,
            radioBtnChangeHandler,
            updateCheckoutDetails,
            cartData,
            kfcToCarCollectionPointCheck,
          })}

        {checkoutDispositionFirstOption !== CHECKOUT_CONSTANTS?.HAND_IT_TO_ME && getHandItToMe()}

        {dispositionOptionInstruction({
          type,
          cartData,
          kfcToCarCollectionPointCheck,
          checkoutDetails,
          updateDispositionOptions,
        })}
      </div>
    </div>
  );
};

export default React.memo(CheckoutDispositionOptionsView);
